// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Book3D-module__scene--n_jSW {  
  --book-height: var(--book-preferred-height);
  --book-thickness: 40px;
  --book-depth: 205px;

  position: relative;
  display: inline-block;

  width: calc(var(--book-thickness));
  height: calc(var(--book-height));

  background: transparent;
  perspective: 1400px;

  padding: 0;
  border: 0;
  cursor: pointer;
}

.Book3D-module__scene--n_jSW:hover {
  transform: translateZ(100deg);
  z-index: 10;
}

.Book3D-module__scene--n_jSW:hover .Book3D-module__book--_8Vcd {
  transform: rotateX(0) rotateY(-90deg) scale(1.2);
}

.Book3D-module__scene--n_jSW .Book3D-module__book--_8Vcd:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.2);
}

.Book3D-module__scene--n_jSW:hover .Book3D-module__book--_8Vcd:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.3);
}

.Book3D-module__scene--n_jSW .Book3D-module__book--_8Vcd .Book3D-module__back--Z8lcx:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0);
  transition: 0.3s all;
}

.Book3D-module__scene--n_jSW:hover .Book3D-module__book--_8Vcd .Book3D-module__back--Z8lcx:after {
  content: '';
  position: absolute;
  top: 100%;
  left: -10%;
  width: 120%;
  height: 20%;
  background-color: rgba(0,0,0,.2);
  border-radius: 50%;

  filter: blur(10px);
}

.Book3D-module__book--_8Vcd {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--book-thickness);
  height: var(--book-height);
  transform-style: preserve-3d;
  transform: rotateX(-12deg) rotateY(-45deg);
  transition: transform 650ms cubic-bezier(0.2, 0.7, 0.2, 1);
}

.Book3D-module__book--_8Vcd:hover {
  transform: rotateX(-15deg) rotateY(-45deg);
}

.Book3D-module__face--lHxBF {
  position: absolute;
  display: block;
  backface-visibility: hidden;
  background-color: #f4eedc;
}

.Book3D-module__face--lHxBF img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
  user-select: none;
}

.Book3D-module__front--E0GqS,
.Book3D-module__back--Z8lcx {
  inset: 0;
}

.Book3D-module__front--E0GqS {
  transform-origin: left center;
  width: var(--book-depth);
  height: var(--book-height);
  /* transform: translateZ(calc(var(--book-depth) / 2)); */
  transform: rotateY(90deg) translateZ(calc(var(--book-thickness)));
}

.Book3D-module__back--Z8lcx {
  transform-origin: left center;
  width: var(--book-depth);
  height: var(--book-height);
  margin-left: calc(var(--book-thickness) * -1);
  transform: rotateY(90deg) translateZ(calc(var(--book-thickness)));
}

.Book3D-module__spine--tKT44 {
  top: 0;
  left: 0;
  width: var(--book-width);
  height: var(--book-height);
}

.Book3D-module__top--vsFfV {
  top: 0;
  left: 0;
  width: var(--book-thickness);
  height: var(--book-depth);
  background: repeating-linear-gradient(0deg, #e0d8c4 0 1px, #faf6e9 1px 3px);
  transform-origin: top center;
  backface-visibility: visible;
  transform: rotateX(-90deg) translateZ(1px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/MemberLibraryPage/components/Book3D/Book3D.module.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,mBAAmB;;EAEnB,kBAAkB;EAClB,qBAAqB;;EAErB,kCAAkC;EAClC,gCAAgC;;EAEhC,uBAAuB;EACvB,mBAAmB;;EAEnB,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,wDAAwD;EACxD,iEAAiE;AACnE;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;EAC7C,iEAAiE;AACnE;;AAEA;EACE,MAAM;EACN,OAAO;EACP,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,yBAAyB;EACzB,2EAA2E;EAC3E,4BAA4B;EAC5B,4BAA4B;EAC5B,0CAA0C;AAC5C","sourcesContent":[".scene {  \n  --book-height: var(--book-preferred-height);\n  --book-thickness: 40px;\n  --book-depth: 205px;\n\n  position: relative;\n  display: inline-block;\n\n  width: calc(var(--book-thickness));\n  height: calc(var(--book-height));\n\n  background: transparent;\n  perspective: 1400px;\n\n  padding: 0;\n  border: 0;\n  cursor: pointer;\n}\n\n.scene:hover {\n  transform: translateZ(100deg);\n  z-index: 10;\n}\n\n.scene:hover .book {\n  transform: rotateX(0) rotateY(-90deg) scale(1.2);\n}\n\n.scene .book:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,.2);\n}\n\n.scene:hover .book:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,.3);\n}\n\n.scene .book .back:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0);\n  transition: 0.3s all;\n}\n\n.scene:hover .book .back:after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: -10%;\n  width: 120%;\n  height: 20%;\n  background-color: rgba(0,0,0,.2);\n  border-radius: 50%;\n\n  filter: blur(10px);\n}\n\n.book {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--book-thickness);\n  height: var(--book-height);\n  transform-style: preserve-3d;\n  transform: rotateX(-12deg) rotateY(-45deg);\n  transition: transform 650ms cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n\n.book:hover {\n  transform: rotateX(-15deg) rotateY(-45deg);\n}\n\n.face {\n  position: absolute;\n  display: block;\n  backface-visibility: hidden;\n  background-color: #f4eedc;\n}\n\n.face img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  user-select: none;\n}\n\n.front,\n.back {\n  inset: 0;\n}\n\n.front {\n  transform-origin: left center;\n  width: var(--book-depth);\n  height: var(--book-height);\n  /* transform: translateZ(calc(var(--book-depth) / 2)); */\n  transform: rotateY(90deg) translateZ(calc(var(--book-thickness)));\n}\n\n.back {\n  transform-origin: left center;\n  width: var(--book-depth);\n  height: var(--book-height);\n  margin-left: calc(var(--book-thickness) * -1);\n  transform: rotateY(90deg) translateZ(calc(var(--book-thickness)));\n}\n\n.spine {\n  top: 0;\n  left: 0;\n  width: var(--book-width);\n  height: var(--book-height);\n}\n\n.top {\n  top: 0;\n  left: 0;\n  width: var(--book-thickness);\n  height: var(--book-depth);\n  background: repeating-linear-gradient(0deg, #e0d8c4 0 1px, #faf6e9 1px 3px);\n  transform-origin: top center;\n  backface-visibility: visible;\n  transform: rotateX(-90deg) translateZ(1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scene": `Book3D-module__scene--n_jSW`,
	"book": `Book3D-module__book--_8Vcd`,
	"back": `Book3D-module__back--Z8lcx`,
	"face": `Book3D-module__face--lHxBF`,
	"front": `Book3D-module__front--E0GqS`,
	"spine": `Book3D-module__spine--tKT44`,
	"top": `Book3D-module__top--vsFfV`
};
export default ___CSS_LOADER_EXPORT___;
